/** User-curated story path — not assigned from book metadata. */
export const FAVOURITE_BOOKS_PATH_ID = 'favourite-books';

export function isBookFavourite(book) {
  return Boolean(book?.is_favourite);
}

export async function toggleFavouriteBook(apiBase, token, bookId) {
  const res = await fetch(`${apiBase}/user/favourites/${encodeURIComponent(bookId)}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || 'Could not update favourite');
  }
  return res.json();
}

export async function fetchFavouriteBookIds(apiBase, token) {
  const res = await fetch(`${apiBase}/user/favourites`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data.favourite_book_ids) ? data.favourite_book_ids : [];
}
